'use client';
import {
    AcquisitionDesktopHeader,
    Banner,
    FAQs,
    HowItWorksSection,
    TestimonialSection,
    WhySellYourCarSection,
} from '@/components/acquisition';

import styles from './styles.module.scss';
import MobileSellCarPage from './mobile-sell-car-page/mobile-sell-car.component';
import { useAsyncIsFlagOn } from '@/hook';
import { FEATURE_FLAG_SELL_PAGE_REVAMP } from '@/constants';
import AcquisitionPageLoader from './acquisitionPageLoader';

const AcquisitionPage = () => {
    const newSellPageExperimentFlag = useAsyncIsFlagOn(
        FEATURE_FLAG_SELL_PAGE_REVAMP
    );

    const renderSellPage = () => {
        if (newSellPageExperimentFlag === 'pending') {
            return <AcquisitionPageLoader />;
        } else {
            return newSellPageExperimentFlag ? (
                <>
                    <MobileSellCarPage />
                    <FAQs />
                </>
            ) : (
                <>
                    <Banner />
                    <HowItWorksSection />
                    <TestimonialSection />
                    <WhySellYourCarSection />
                    <FAQs />
                </>
            );
        }
    };
    return (
        <div>
            <div className={styles.desktop_header}>
                <AcquisitionDesktopHeader />
                <HowItWorksSection />
                <TestimonialSection />
                <WhySellYourCarSection />
                <FAQs />
            </div>
            <div className={styles.banner_contianer}>{renderSellPage()}</div>
        </div>
    );
};

export default AcquisitionPage;
